

export function NoScriptFallback() {
  return (
    <>
      <noscript>
        <div className="min-h-screen bg-gradient-to-br from-primary-green to-bg-dark flex items-center justify-center p-4">
          <div className="max-w-2xl w-full bg-white rounded-lg shadow-xl p-8">
            {/* Header */}
            <div className="text-center mb-8">
              <img 
                src="https://petgascoin.com/assets/images/logo_Big.png" 
                alt="PGC Logo" 
                className="w-32 h-32 mx-auto mb-6"
              />
              <h1 className="text-3xl font-bold text-primary-green mb-4">
                $PGC TO THE MOON! 🚀
              </h1>
              <p className="text-lg text-gray-700 mb-6">
                Limited-time airdrop🔥 Get your $PGC now. We're building a sustainable future by turning plastic waste into clean energy.
              </p>
            </div>

            {/* JavaScript Required Notice */}
            <div className="bg-yellow-50 border-2 border-yellow-200 rounded-lg p-6 mb-8">
              <div className="flex items-start">
                <svg className="h-6 w-6 text-yellow-500 mr-3 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
                <div>
                  <h3 className="text-lg font-semibold text-yellow-800 mb-2">
                    JavaScript Required
                  </h3>
                  <p className="text-yellow-700 mb-4">
                    This whitelist registration form requires JavaScript to function properly. Please enable JavaScript in your browser to continue with the registration process.
                  </p>
                  <div className="text-sm text-yellow-600">
                    <p className="mb-2"><strong>Why JavaScript is needed:</strong></p>
                    <ul className="list-disc list-inside space-y-1 ml-4">
                      <li>Real-time form validation</li>
                      <li>Secure wallet address verification</li>
                      <li>Duplicate entry prevention</li>
                      <li>Enhanced user experience with animations</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* How to Enable JavaScript */}
            <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-6 mb-8">
              <h3 className="text-lg font-semibold text-blue-800 mb-4">
                How to Enable JavaScript
              </h3>
              <div className="space-y-4 text-sm text-blue-700">
                <div>
                  <h4 className="font-semibold mb-2">Chrome:</h4>
                  <ol className="list-decimal list-inside space-y-1 ml-4">
                    <li>Click the three dots menu → Settings</li>
                    <li>Click "Privacy and security" → "Site Settings"</li>
                    <li>Click "JavaScript" and toggle "Allowed"</li>
                    <li>Refresh this page</li>
                  </ol>
                </div>
                
                <div>
                  <h4 className="font-semibold mb-2">Firefox:</h4>
                  <ol className="list-decimal list-inside space-y-1 ml-4">
                    <li>Type "about:config" in the address bar</li>
                    <li>Search for "javascript.enabled"</li>
                    <li>Set the value to "true"</li>
                    <li>Refresh this page</li>
                  </ol>
                </div>
                
                <div>
                  <h4 className="font-semibold mb-2">Safari:</h4>
                  <ol className="list-decimal list-inside space-y-1 ml-4">
                    <li>Safari menu → Preferences</li>
                    <li>Click "Security" tab</li>
                    <li>Check "Enable JavaScript"</li>
                    <li>Refresh this page</li>
                  </ol>
                </div>
              </div>
            </div>

            {/* Alternative Contact Method */}
            <div className="bg-green-50 border-2 border-green-200 rounded-lg p-6">
              <h3 className="text-lg font-semibold text-green-800 mb-4">
                Alternative Registration Method
              </h3>
              <p className="text-green-700 mb-4">
                If you're unable to enable JavaScript, you can still register for the $PGC whitelist by contacting us directly:
              </p>
              <div className="space-y-2 text-sm text-green-600">
                <p><strong>Email:</strong> <a href="mailto:contact@petgascoin.com" className="underline hover:no-underline">contact@petgascoin.com</a></p>
                <p><strong>Subject:</strong> Whitelist Registration Request</p>
                <p><strong>Include:</strong></p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Your full name</li>
                  <li>Your email address</li>
                  <li>Your BNB wallet address (starting with 0x)</li>
                  <li>Mention "JavaScript disabled registration"</li>
                </ul>
              </div>
            </div>

            {/* Footer */}
            <div className="text-center mt-8 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                © 2024 PetGasCoin. Building a sustainable future through blockchain technology.
              </p>
            </div>
          </div>
        </div>
      </noscript>
    </>
  );
}